module.exports = __webpack_public_path__ + "static/media/clear.51fd624d.png";